import { integer, pgTable, text, timestamp, uniqueIndex, uuid } from "drizzle-orm/pg-core";
import { catalogItems } from "./catalog-item";

/**
 * Standing procurement need, 1:1 with a catalog item. No status: quantity 0 means
 * nothing to buy. Writer: velocity CREATE engine and platform staff.
 */
export const procurementNeeds = pgTable(
  "procurement_needs",
  {
    id: uuid("id").primaryKey().defaultRandom(),
    catalogItemId: uuid("catalog_item_id")
      .notNull()
      .references(() => catalogItems.id),
    quantityNeeded: integer("quantity_needed").notNull().default(0),
    urgency: integer("urgency"),
    dueAt: timestamp("due_at", { withTimezone: true }),
    notes: text("notes"),
    createdAt: timestamp("created_at", { withTimezone: true }).notNull().defaultNow(),
    updatedAt: timestamp("updated_at", { withTimezone: true }).notNull().defaultNow(),
  },
  (t) => [uniqueIndex("procurement_needs_catalog_item_idx").on(t.catalogItemId)],
);
